import axios from 'axios';
import ParkingToolSpace from "./ParkingToolTypes";

export { parkingToolActions };

function parkingToolActions() {
    const baseUrl = ``;

    return {
        downloadParkingToolExcelReport
    }


    async function downloadParkingToolExcelReport(tenant:string,request: ParkingToolSpace.Request) {
        return new Promise(function (resolve, reject) {
            axios.post(`${baseUrl}/parkingtool/downloadParkingToolExcelReport`, request, {
                params:{tenant:tenant},
                responseType: 'arraybuffer',
                headers: { 'Access-Control-Allow-Origin': true }
            }
            ).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error)
            })
        });
    }

}
